import { SectionCard } from "../../../components/SectionCard";
import { Button } from "../../../components/ui/button";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";
import { navigate } from "../../../lib/router";
import { FileText } from "lucide-react";

export function ContractSection() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].contract;

  return (
    <SectionCard
      header={<div className="font-semibold">{t.header}</div>}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-neutral-500">
          {t.description}
        </p>
        <Button 
          className="w-full justify-between" 
          variant="outline"
          onClick={() => navigate("/app/settings/contract")}
        >
          {t.button}
          <FileText className="h-4 w-4 ml-2 text-neutral-400" />
        </Button>
      </div>
    </SectionCard>
  );
}

export default ContractSection;
